import { translate as t } from '@thoughtspot/i18n';
import {
    Horizontal,
    Vertical,
} from '@thoughtspot/radiant-react/widgets/layout';
import {
    Colors,
    Typography,
} from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React, { useState } from 'react';
import styles from './primary-column.module.scss';

export interface PrimaryColumnProps {
    primaryText: string;
    secondaryText: any;
    handleClick: () => void;
}
export const PrimaryColumn: React.FC<PrimaryColumnProps> = ({
    primaryText,
    secondaryText,
    handleClick,
}) => {
    const desc = secondaryText || '';
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const maxLength = 60;
    const shouldTruncate = desc.length > maxLength;
    const displayText =
        isExpanded || !shouldTruncate ? desc : `${desc.slice(0, maxLength)}...`;

    return (
        <Vertical className={styles.insightsNameContainer}>
            <Typography
                variant="content-label-subhead"
                noMargin
                ellipsis={{ rows: 1 }}
                className={styles.insightLink}
                onClick={handleClick}
                tooltipConfig={{
                    dataTooltipContent: primaryText,
                    dataTooltipPosition: 'top',
                }}
            >
                {primaryText}
            </Typography>
            {desc && (
                <Horizontal className={styles.fullWidth} spacing="a">
                    <div
                        className={cx(styles.fullWidth, {
                            [styles.fullWidthMinusMoreWidth]:
                                shouldTruncate && !isExpanded,
                        })}
                    >
                        {!isExpanded ? (
                            <Typography
                                variant="footnote"
                                noMargin
                                tooltipConfig={desc}
                                color={Colors.grayLight}
                                ellipsis={{ rows: 1 }}
                            >
                                {displayText}
                            </Typography>
                        ) : (
                            <Typography
                                variant="footnote"
                                tooltipConfig={desc}
                                ellipsis={{ rows: 3 }}
                                color={Colors.grayLight}
                            >
                                {displayText}
                            </Typography>
                        )}
                    </div>
                    {shouldTruncate && !isExpanded && (
                        <span className={styles.showMoreWrapper}>
                            <Typography
                                variant="footnote"
                                className={styles.moreText}
                                noMargin
                                onClick={(e: any) => {
                                    e.stopPropagation();
                                    setIsExpanded(true);
                                }}
                            >
                                {t('ObjectTable.More' as any)}
                            </Typography>
                        </span>
                    )}
                </Horizontal>
            )}
        </Vertical>
    );
};
